import dropdownConstants from '../../constants';
import computeClassName from '../../../../../../../utils/computeClassName';
import CCIconChevronDown8x8 from '../../../../Icon/Chevron/Down/8x8';
import CCIconChevronDown12x12 from '../../../../Icon/Chevron/Down/12x12';
import ProcessingIndicator from '../../../../../../PartnerFinderApp/ProcessingIndicator';

const constants = Object.freeze({
  CLASSNAME_BASE: 'appearance-none rounded-r-lg text-cc-primary-contrast flex items-center justify-center',
  CLASSNAME_DROPDOWN_SIZE: Object.fromEntries(
    new Map([
      [dropdownConstants.SIZE_XSMALL, 'w-8 h-7'],
      [dropdownConstants.SIZE_SMALL, 'w-11 h-10'],
      [dropdownConstants.SIZE_MEDIUM, 'w-11 h-10'],
      [dropdownConstants.SIZE_LARGE, 'w-15 h-14']
    ])
  ),

  CLASSNAME_ICON_BASE: 'transform-gpu transition-transform duration-100 ease-linear',
  CLASSNAME_ICON_DROPDOWN_IS_OPENED: {
    true: {
      DROPDOWN_IS_LTR: {
        true: 'rotate-0',
        false: '-rotate-0'
      }
    },
    false: {
      DROPDOWN_IS_LTR: {
        true: 'rotate-180',
        false: '-rotate-180'
      }
    }
  },

  COMPONENT_ICON_DROPDOWN_SIZE: Object.fromEntries(
    new Map([
      [dropdownConstants.SIZE_XSMALL, CCIconChevronDown8x8],
      [dropdownConstants.SIZE_SMALL, CCIconChevronDown8x8],
      [dropdownConstants.SIZE_MEDIUM, CCIconChevronDown8x8],
      [dropdownConstants.SIZE_LARGE, CCIconChevronDown12x12]
    ])
  ),

});

function getComputedClassName(propsClassName, dropdownSize) {
  return computeClassName(
      propsClassName,
      `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_SIZE[dropdownSize]}`
    );
}

function getComputedIconClassName(dropdownIsOpened, dropdownIsLTR) {
  return `${constants.CLASSNAME_ICON_BASE} ${constants.CLASSNAME_ICON_DROPDOWN_IS_OPENED[dropdownIsOpened].DROPDOWN_IS_LTR[dropdownIsLTR]}`;
}

function getComputedIconComponent(dropdownSize) {
  return constants.COMPONENT_ICON_DROPDOWN_SIZE[dropdownSize];
}

export default function CCFormDropdownOpenCloseControlIcon(
  {
    dropdownSize,
    dropdownIsOpened,
    dropdownIsProcessingInProgress,
    dropdownIsLTR,
    className = ''
}) {
  const computedClassName = getComputedClassName(className, dropdownSize);
  const computedIconClassName = getComputedIconClassName(dropdownIsOpened, dropdownIsLTR);
  const ComputedIconComponent = getComputedIconComponent(dropdownSize);
  return (
    <span className={computedClassName} aria-hidden="true">
      {
        dropdownIsProcessingInProgress ?
          <ProcessingIndicator size="medium"/> :
          <ComputedIconComponent className={computedIconClassName}/>
      }
    </span>
  );
}
